// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import ClaimAction from '@deere/cps-it.warranty-model-factory/lib/claim-action';
import ClaimActionPopover from './claim-action-popover';
import ClaimPrimaryAction from './claim-primary-action';

const ClaimActionButtons = props =>
    <section className='claim-action-buttons'>
        <ClaimActionPopover
            actions={props.allowedActions}
            claimNumber={props.claimNumber}
            claimStatus={props.claimStatus}
            creditMemoNumber={props.creditMemoNumber}
            isActionButtonDisabled={props.isActionButtonDisabled}
            onActionClick={props.onActionClick}
        />
        <ClaimPrimaryAction
            actions={props.allowedActions}
            className='claim-primary-action'
            isActionButtonDisabled={props.isActionButtonDisabled}
            onActionClick={props.onActionClick}
        />
    </section>;

ClaimActionButtons.displayName = 'ClaimsActionsButton';
ClaimActionButtons.propTypes = {
    allowedActions: PropTypes.arrayOf(PropTypes.instanceOf(ClaimAction)).isRequired,
    claimNumber: PropTypes.string.isRequired,
    claimStatus: PropTypes.string.isRequired,
    creditMemoNumber: PropTypes.string.isRequired,
    isActionButtonDisabled: PropTypes.bool.isRequired,
    onActionClick: PropTypes.func.isRequired
};

export default ClaimActionButtons;



// WEBPACK FOOTER //
// ./src/claim/shared/components/claim-action-button/index.js